import { useSite } from "@/context/SiteContext";
import { useSeo } from "@/hooks/useSeo";
import { Hero, Ticker } from "@/components/home/Hero";
import { FeaturedWork } from "@/components/home/FeaturedWork";
import { ServicesSection, PricingSection } from "@/components/home/ServicesPricing";
import { HowItWorks, WhyEditBay, AgencySection, FaqSection, CtaSection } from "@/components/home/Sections";
import { ErrorState } from "@/components/site/Primitives";
import { faqJsonLd } from "@/components/site/FaqList";
import { AboutSection } from "@/components/home/About";
import { orgLd, websiteLd } from "@/lib/jsonld";

const MAP = {
  portfolio: FeaturedWork, services: ServicesSection, pricing: PricingSection, how_it_works: HowItWorks,
  why: WhyEditBay, agency: AgencySection, about: AboutSection, faqs: FaqSection, cta: CtaSection,
};

export default function Home() {
  const { site, services, faqs, loading, error, reload } = useSite();
  const homeFaqs = faqs.filter((f) => f.show_on_homepage);
  useSeo("home", "/", {}, [orgLd(site), websiteLd(site), faqJsonLd(homeFaqs)]);
  if (loading && !site) return <div className="min-h-[80vh] bg-[#050505] animate-pulse" data-testid="home-loading" />;
  if (error && !site) return <div className="eb-container py-32"><ErrorState message={error} onRetry={reload} /></div>;
  let n = 0;
  return (
    <div data-testid="home-page">
      <Hero site={site} services={services} />
      <Ticker />
      {(site.sections || []).filter((s) => s.visible && MAP[s.key]).map((s) => {
        const C = MAP[s.key];
        const index = s.key === "cta" ? null : String(++n).padStart(2, "0");
        return <C key={s.key} meta={s} index={index} site={site} services={services} faqs={faqs} />;
      })}
    </div>
  );
}
